import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

function Home() {
  return (
    <main className="home">
      <section className="hero">
        <div className="hero-tag">{'// CS + Applied Mathematics'}</div>
        <h1 className="hero-name">Nathaniel<br />Song</h1>
        <p className="hero-sub">
          Building tools at the intersection of pure mathematics and software.
          Knot theory, ML, systems.
        </p>
        <div className="hero-btns">
          <Link to="/projects" className="keybtn blue">
            <span className="keybtn-face">View projects</span>
            <span className="keybtn-shadow"></span>
          </Link>
          <Link to="/research" className="keybtn red">
            <span className="keybtn-face">Read research</span>
            <span className="keybtn-shadow"></span>
          </Link>
        </div>
      </section>

      <section className="stats">
        {[
          { num: '2', label: 'Majors' },
          { num: '4+', label: 'Conferences' },
          { num: '6+', label: 'Projects' },
          { num: 'Java', label: 'Primary Language' },
        ].map((s) => (
          <div className="stat" key={s.label}>
            <div className="stat-num">{s.num}</div>
            <div className="stat-label">{s.label}</div>
          </div>
        ))}
      </section>

      <section className="featured">
        <div className="section-label">{'// Featured projects'}</div>
        <div className="proj-grid">
          {[
            { title: 'Knot theory API', desc: 'GPV finite-type invariants from Gauss diagrams. Go + AWS Lambda.', tag: 'Mathematics', color: '#1A4FCC' },
            { title: 'IT ticket classifier', desc: 'NLP routing with TF-IDF + LinearSVC. Confidence thresholding.', tag: 'ML / NLP', color: '#CC1100' },
            { title: 'Kaggle predictor', desc: 'Customer upgrade prediction with XGBoost + SMOTE.', tag: 'Machine learning', color: '#2E7A30' },    
          ].map((p) => (
            <div className="proj-card" key={p.title} style={{ borderLeftColor: p.color }}>
              <div className="proj-title">{p.title}</div>
              <div className="proj-desc">{p.desc}</div>
              <span className="proj-tag" style={{ background: p.color }}>{p.tag}</span>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}

export default Home;